import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { LocalNotifications } from "@capacitor/local-notifications";
import { Preferences } from "@capacitor/preferences";

const ASKED_KEY = "ln_perm_asked_v1";

export function useAskLocalNotifOnFirstLaunch() {
  useEffect(() => {
    const run = async () => {
      const platform = Capacitor.getPlatform();
      if (platform !== "android" && platform !== "ios") return;

      const { value: asked } = await Preferences.get({ key: ASKED_KEY });
      if (asked === "yes") return;

      try {
        const perm = await LocalNotifications.checkPermissions();
        if (perm.display !== "granted") {
          const req = await LocalNotifications.requestPermissions();
          await Preferences.set({ key: ASKED_KEY, value: "yes" });

          /*if (req.display === "granted") {
            // 🔔 Notificación de prueba
            const in5s = new Date(Date.now() + 5000);
            await LocalNotifications.schedule({
              notifications: [
                {
                  id: 10001,
                  title: "Prueba de notificación",
                  body: "¡Permiso concedido! Esto es un recordatorio de prueba.",
                  schedule: { at: in5s },
                },
              ],
            });
          }*/
        } else {
          await Preferences.set({ key: ASKED_KEY, value: "yes" });
        }
      } catch (e) {
        console.warn("Error solicitando permiso de LocalNotifications:", e);
      }
    };
    run();
  }, []);
}
